import React, { useEffect, useState } from 'react';
import BatteryStatusCard from './BatteryStatusCard';
import CpuLoadCard from './CpuLoadCard';
import DiskIOCard from './DiskIOCard';
import MemoryUsageCard from './MemoryUsageCard';
import NetIOCard from './NetIOCard';
import NetworkInterfacesCard from './NetworkInterfacesCard';
import PacketStatsTable from './PacketStatsTable';
import SystemInfoCard from './SystemInfoCard';
import { DroneHeartBeat } from '../../models/DroneProfile/DroneProfile.model';
import { DroneProfileService } from '../../services/DroneProfileService';

interface HeartBeatProps {
  droneId: string;
}

const HeartBeat: React.FC<HeartBeatProps> = ({ droneId }) => {
  const [heartbeat, setHeartbeat] = useState<DroneHeartBeat | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!droneId) return;
    setLoading(true);
    setError(null);
    DroneProfileService.getDroneHeartBeat(droneId)
      .then((res) => {
        if (res.success && res.data) {
          setHeartbeat(res.data);
        } else {
          setError('Failed to fetch heartbeat data.');
        }
      })
      .catch(() => setError('Failed to fetch heartbeat data.'))
      .finally(() => setLoading(false));
  }, [droneId]);

  if (loading) return <div>Loading heartbeat...</div>;
  if (error) return <div>{error}</div>;
  if (!heartbeat) return <div>No heartbeat data available.</div>;

  return (
    <div>
      <BatteryStatusCard heartbeat={heartbeat} />
      <CpuLoadCard heartbeat={heartbeat} />
      <DiskIOCard heartbeat={heartbeat} />
      <MemoryUsageCard heartbeat={heartbeat} />
      <NetIOCard heartbeat={heartbeat} />
      <NetworkInterfacesCard heartbeat={heartbeat} />
      <PacketStatsTable heartbeat={heartbeat} />
      <SystemInfoCard heartbeat={heartbeat} />
    </div>
  );
};

export default HeartBeat;